import { Root as o } from "./components/Root/index.js";
import { List as r } from "./components/List/index.js";
import { NextIndicator as t } from "./components/NextIndicator/index.js";
import { PrevIndicator as m } from "./components/PrevIndicator/index.js";
import { ListItem as i } from "./components/List/styles.js";
const c = {
  Root: o,
  List: r,
  ListItem: i,
  NextIndicator: t,
  PrevIndicator: m
};
export {
  c as Carousel
};
